import React from 'react';


const MedalCriteria = () => {

    return (
		<div class="page-body">
			<p id="6ca5a26f-c3c1-45f7-9920-9468f26e5009" class=""><strong><strong>Bronze - All criteria must be
						met</strong></strong></p>
			<table id="c8f77387-83c8-4685-924a-ce77b6913da6" class="simple-table">
				<tbody>
					<tr id="d688b4de-4125-4168-89cd-aff5d33885d3">
						<td id="e:A;" class="">Number</td>
						<td id="Gyz^" class="">Name</td>
						<td id="Ripa" class="">Explanation</td>
						<td id="SbHG" class="">Our work</td>
					</tr>
					<tr id="acb19565-7ace-4de5-b0cb-1cbdf966f21d">
						<td id="e:A;" class="">1</td>
						<td id="Gyz^" class="">Competition Deliverables</td>
						<td id="Ripa" class="">Complete the following Competition Deliverables: Wiki, Project Promotion
							Video, Presentation Video, Judging Form, and Judging Session</td>
						<td id="SbHG" class="">Delivered all required deliverables.
							Check out our promotion video here: <a
								href="https://video.igem.org/w/qPuTTsx6hyyBUAgp1U3BiM">https://video.igem.org/w/qPuTTsx6hyyBUAgp1U3BiM</a>
							(presentation video TBA)</td>
					</tr>
					<tr id="e2a118e6-69cf-47ef-bd8f-6e69fdf47025">
						<td id="e:A;" class="">2</td>
						<td id="Gyz^" class="">Project Attributions</td>
						<td id="Ripa" class="">Describe what work your team members did and what other people did for
							your project using the standardized form.
						</td>
						<td id="SbHG" class="">Fulfilled project attributions.
							<a
								href="https://2023.igem.wiki/paris-bettencourt/attributions">https://2023.igem.wiki/paris-bettencourt/attributions</a>
						</td>
					</tr>
					<tr id="090c3a1a-4174-4e9d-b092-ed2f7c1a8828">
						<td id="e:A;" class="">3</td>
						<td id="Gyz^" class="">Project Description</td>
						<td id="Ripa" class="">Describe how and why you chose your iGEM project.</td>
						<td id="SbHG" class=""><a
								href="https://2023.igem.wiki/paris-bettencourt/description">https://2023.igem.wiki/paris-bettencourt/description</a>
						</td>
					</tr>
					<tr id="e699591d-a870-41fd-b83a-c953a9ecc1df">
						<td id="e:A;" class="">4</td>
						<td id="Gyz^" class="">Contribution</td>
						<td id="Ripa" class="">Make a useful contribution for future iGEM teams.</td>
						<td id="SbHG" class="">Made many contributions towards future iGEM projects through our human
							practice, entrepreneurship, modelling and wetlab work. <a
								href="https://2023.igem.wiki/paris-bettencourt/contribution">https://2023.igem.wiki/paris-bettencourt/contribution</a>
						</td>
					</tr>
				</tbody>
			</table>
			<p id="ecd8d528-f077-46a9-9cdd-5b3d9c534d76" class=""><strong><strong>Silver - All Bronze and all Silver
						criteria must be met</strong></strong></p>
			<table id="1728ed94-78ec-477c-98e1-4c7b1f7921a6" class="simple-table">
				<tbody>
					<tr id="87ccbdf3-2e6b-431b-9434-87576c1077d4">
						<td id="c^Xd" class="">Number</td>
						<td id="Ji_M" class="">Name</td>
						<td id="cdOx" class="">Explanation</td>
						<td id="u;qL" class="">Our work</td>
					</tr>
					<tr id="e2ac95c3-907f-48e7-969e-504cc46aae7e">
						<td id="c^Xd" class="">1</td>
						<td id="Ji_M" class="">Engineering Success</td>
						<td id="cdOx" class="">Demonstrate engineering success in a technical aspect of your project by
							going through at least one iteration of the engineering design cycle.
						</td>
						<td id="u;qL" class="">Many iterations of the engineering cycle conducted in both the wet and
							dry lab, through developmeent and optimisation of our process. <a
								href="https://2023.igem.wiki/paris-bettencourt/engineering">https://2023.igem.wiki/paris-bettencourt/engineering</a>
						</td>
					</tr>
					<tr id="156416fb-b520-435a-88ca-a9a2bfaf1afc">
						<td id="c^Xd" class="">2</td>
						<td id="Ji_M" class="">Human Practices</td>
						<td id="cdOx" class="">Explain how you have determined your work is responsible and good for the
							world.</td>
						<td id="u;qL" class="">Human practices was a key aspect in our project, of which the concept can
							directly impact people of all niches. <a
								href="https://2023.igem.wiki/paris-bettencourt/human-practices">https://2023.igem.wiki/paris-bettencourt/human-practices</a>
						</td>
					</tr>
				</tbody>
			</table>
			<p id="9d0427d3-dc97-4a6e-966a-24f6b26bb927" class=""><strong><strong>Gold - All Bronze, Silver and Gold
						criteria must be met</strong></strong></p>
			<table id="6b6ae361-9670-4c64-bc7f-8efb6341f586" class="simple-table">
				<tbody>
					<tr id="607e5eee-12b2-42de-8b4c-63e8c211f0bf">
						<td id="Y]:h" class="">Number</td>
						<td id="SgbP" class="">Name</td>
						<td id="Ptiz" class="">Explanation</td>
						<td id="@ztd" class="">Our work</td>
					</tr>
					<tr id="5de934ed-657e-4b27-9d4e-9c35bd44b99c">
						<td id="Y]:h" class="">1</td>
						<td id="SgbP" class="">Excellence in Synthetic Biology</td>
						<td id="Ptiz" class="">Impress the judges with your work towards three special prizes of your
							choice. You must demonstrate excellence in both General Biological Engineering and in at
							least one Specialization.
							<em>Note:</em> Software Track teams cannot nominate themselves for the Software Special
							Prize as a Gold medal criterion. By competition rules, teams in the Software Track are not
							eligible to win the Software Special Prize.
						</td>
						<td id="@ztd" class=""><a
								href="https://2023.igem.wiki/paris-bettencourt/model">https://2023.igem.wiki/paris-bettencourt/model</a>

							<a
								href="https://2023.igem.wiki/paris-bettencourt/human-practices">https://2023.igem.wiki/paris-bettencourt/human-practices</a>

							<a
								href="https://2023.igem.wiki/paris-bettencourt/entrepreneurship">https://2023.igem.wiki/paris-bettencourt/entrepreneurship</a>
						</td>
					</tr>
				</tbody>
			</table>
			<p id="8ae344b7-6a58-41cb-9a4a-a3ef901f0074" class="">
			</p>
		</div>

    )
}
export default MedalCriteria;